export default {
    CHANGE_QUESTION_MODEL_CONFIRM_DIALOG: {
        MESSAGE: 'By changing the model of this question, any information answered already to this question will be lost. Contact Enginehire with any questions.',
        ACCEPT_LABEL: 'Continue',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_REFERENCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this reference?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_EXPERIENCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this experience?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_CONTACT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this contact?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_EDUCATION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this education?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_CHILDREN_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this child?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PET_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this pet?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this booking?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PROFILE_BUILDER_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the profile builder {0}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this request?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this job?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_APPLICATION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this application?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the document {0}?',
        ACCEPT_LABEL: 'Delete Document',
        REJECT_LABEL: 'Close'
    },
    BULK_DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you absolutely sure you want to delete these documents?',
        ACCEPT_LABEL: 'Delete Documents',
        REJECT_LABEL: 'Close'
    },
    DELETE_FILE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the file?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Close'
    },
    DELETE_TEMPLATE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the {0} template {1}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PRICE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the {0} {1}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PHOTO_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the photo {0}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the picture?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_USER_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Are you sure you want to delete this user?</h3>
        <p>{0} {1}</p>
        <p>{2}</p>`,
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_ADMIN_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Are you sure you want to delete this user?</h3>
        <p>{0}</p>`,
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to remove {0}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_TIME_OFF_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to remove this timeoff request',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    CANCEL_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to cancel this booking?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    CANCELLATION_FEE_CONFIRM_DIALOG: {
        MESSAGE: 'Cancellation Fee is ${0}. Are you sure you want to continue?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    CANCEL_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to close? Any changes will be lost.',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to accept the job {0}?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    DECLINE_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to decline the job {0}?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    EDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure of your changes?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    BULK_OVERWRITE_DATA_CONFIRM_DIALOG: {
        INNER_HTML: `<h2>Are you sure you want to overwrite {0} of the selected users?</h2><h5 class="text-danger">This will overwrite these user's existing {0} with "{1}".</h5>`,
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    BULK_ADD_DATA_CONFIRM_DIALOG: {
        INNER_HTML: `<h2>Are you sure you want to add {0} to the selected users?</h2><h5 class="text-danger">This will add "{1}" to user's existing {0}.</h5>`,
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    BULK_STATUS_CHANGE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to change the status of the {0} selected users? Their status will be changed to {1}.',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    BULK_ADD_USER_MAILCHIMP_CONFIRM_DIALOG: {
        INNER_HTML: `<h2>Are you sure you want to add the selected users to mailchimp?</h2>`,
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    OVERWRITE_VIDEO_CONFIRM_DIALOG: {
        MESSAGE: 'There is a recorded video. If you record new video, the existed video will be overwritten. Are you sure to continue?',
        ACCEPT_LABEL: 'Continue',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_VIDEO_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the video?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PROFILE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the profile picture?',
        ACCEPT_LABEL: 'Delete Picture',
        REJECT_LABEL: 'Close'
    },
    DELETE_RELATIONSHIP_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to remove the link between {0} and this client?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    CANDIDATE_ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'You are committing to filling this job, are you sure?',
        ACCEPT_LABEL: 'Accept Job',
        REJECT_LABEL: 'Close'
    },
    MARK_AS_FAVORITE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to mark {0} as favorite?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    MARK_AS_DO_NOT_WANT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you do not want {0} again?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    DELETE_NOTE_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Are you sure you want to delete the note?</h3>
        <p style="white-space: pre-wrap;">{0}</p>`,
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_EVENT_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Are you sure you want to delete the event scheduler?</h3>
        <p style="white-space: pre-wrap;">{0}</p>`,
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_CREDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this credit?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_MULTI_ITEMS_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure you want to delete the {0} selected {1}?",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    UNASSIGN_JOBS_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to unassign {0} selected jobs? Their status will be put to "{1}".',
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    BULK_CHANGE_JOB_STATUS_CONFIMR_DIALOG: {
        MESSAGE: "Are you sure you want to change the status of the {0} selected jobs? Their status will be changed to {1}.",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    ASSIGN_JOB_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure you want to assign the job to the candidate?",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    BULK_ASSIGN_CANDIDIATES_TO_MULTIPLE_JOBS_DIALOG: {
        MESSAGE: "Are you sure you want to assign {0} selected jobs to the selected candidate?",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    BULK_TENTATIVELY_ASSIGN_CANDIDIATES_TO_MULTIPLE_JOBS_DIALOG: {
        MESSAGE: "Are you sure you want to tentatively assign {0} selected jobs to the selected candidate?",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    PACKAGE_SELECTION_CONFIRMATION: {
        INNER_HTML: `<h2>Confirm Selection - {0}</h2>
        <hr />
        <h5>
          I have read and am confident of the terms and conditions with the
          package chosen.
        </h5>`,
        ACCEPT_LABEL: "Confirm Selection",
        REJECT_LABEL: "Cancel"
    },
    DELETE_EVALUATION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this evaluation?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_QUESTION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this question?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_OPTION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this option?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    POST_WEEK_AVAILABLITY_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure of the availability you have entered?',
        ACCEPT_LABEL: 'Confirm Availability',
        REJECT_LABEL: 'Wait, Let Me Check Again'
    },
    TIME_OFF_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure of your request?',
        ACCEPT_LABEL: 'Submit Request',
        REJECT_LABEL: 'Edit Request'
    },
    REMOVE_AVAILABILITY_CONFIRM_DIALOG: {
        MESSAGE: '{0} ({1}) - Remove Availability',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_WEEK_AVAILABILITY_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the weekly availability?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    RESET_WEEK_AVAILABILITY: {
        MESSAGE: 'Are you sure you want to reset the weekly availability?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    SUBMIT_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure of your request?",
        ACCEPT_LABEL: "Submit Request",
        REJECT_LABEL: "Edit Request"
    },
    SUBMIT_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure of your request?",
        ACCEPT_LABEL: "Submit Request",
        REJECT_LABEL: "Edit Request"
    },
    FORCE_LOGIN_CONFIRM_DIALOG: {
        INNER_HTML: '<h4>You are already logged in!</h4>'
            + '<h5>Sorry, it seems you are already logged in on another device! '
            + 'Please log out from anywhere else and try again. '
            + 'If you have any questions please <a href="https://share.hsforms.com/1yIx2IRKyQQaVcMJW8kLbJg39wil">contact us</a>.</h5>',
        ACCEPT_LABEL: 'Login Anyway',
        REJECT_LABEL: 'OK'
    },
    MARK_ALL_AS_PUBLIC_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure you want to mark all {0} as public (visible to everyone)?",
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    BROADCAST_SMS_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure you want to send SMS to {0} users",
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    CREATE_JOB_CONFIRM_DIALOG: {
        INNER_HTML: '<h4>Create Job</h4>'
            + '<hr>' +
            '<h5>If you are starting a job, but it is not listed on your schedule, please use this option.' +
            ' This will create a new job that you can clock in and out of, and we will fill in the other details later.' +
            ' When clocking in, please note which client you are working for and anything else we should know.</h5>',
        ACCEPT_LABEL: 'Create Job',
        REJECT_LABEL: 'Cancel'
    },
    ASSIGN_TO_NOT_MATCH_CANDIDATE: {
        MESSAGE: "There is a relationship 'Do Not Match' between client and candidate. Are you sure you want to assign the booking to this candidate?",
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    ASSIGN_TO_UNAVAILABLE_CANDIDATE: {
        MESSAGE: "Candidate is not available. Are you sure you want to assign the booking to this candidate?",
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    ASSIGN_TO_ALREADY_BOOKED_CANDIDATE: {
        MESSAGE: "Candidate is already booked at this time.. Are you sure you want to assign the booking to this candidate?",
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    ASSIGN_TO_TIME_OFF_CANDIDATE: {
        MESSAGE: "Candidate has time off at this time. Are you sure you want to assign the booking to this candidate?",
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    RELEASE_SCHEDULE_CONFIRM_DIALOG: {
        MESSAGE: "Are you ready to release the schedule?",
        ACCEPT_LABEL: 'Release Schedule',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_BOOKING_GROUP_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure you want to delete the booking group?",
    },
    ACCEPT_BOOKING_IN_GROUP_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>The booking belongs to a group. Are you sure you want to accept all of the bookings in that group?</h3>
        <ul>{0}</ul>`,
        ACCEPT_LABEL: "Accept All",
        REJECT_LABEL: "Cancel"
    },
    UPDATE_JOB_POSTER_CONFRM_DIALOG: {
        MESSAGE: "Do you want to update address fields accordingly with new job poster?",
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    CLIENT_CONFIRM_CLOCK_IN_OUT_MESSAGE: {
        INNER_HTML: "<h3>Clock in and clock out time of the candidate</h3>" +
            "<ul>{0}</ul>",
        ACCEPT_LABEL: 'Approve',
        REJECT_LABEL: 'Cancel'
    },
    CLIENT_APPROVE_CLOCK_IN_OUT_MESSAGE: {
        INNER_HTML: "<h3>Are you sure you want to approve clock in and clock out time of the candidate</h3>" +
            "<ul>{0}</ul>",
        ACCEPT_LABEL: 'Approve',
        REJECT_LABEL: 'Cancel'
    },
    CLIENT_DISSAPPROVE_CLOCK_IN_OUT_MESSAGE: {
        INNER_HTML: "<h3>Are you sure you want to disapprove clock in and clock out time of the candidate</h3>" +
            "<ul>{0}</ul>",
        ACCEPT_LABEL: 'Disapprove',
        REJECT_LABEL: 'Cancel'
    },
    SELECT_CREDIT_PACKAGE_CONFIRM_DIALOG: {
        MESSAGE: "You will be charged {0}{1} for {2} credits. Are you sure you want to continue",
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    SELECT_SUBSCRIPTION_CREDIT_PACKAGE_CONFIRM_DIALOG: {
        MESSAGE: "You will be subscribed for {0} monthly credits. Are you sure you want to continue",
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    CHANGE_SUBSCRIPTION_CREDIT_PACKAGE_CONFIRM_DIALOG: {
        MESSAGE: "You will be subscribed for {0} monthly credits. Are you sure you want to update your current package",
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    SELECT_STRIPE_SUBSCRIPTION_CONFIRM_DIALOG: {
        MESSAGE: "You will be subscribed to {0}. Do you want to continue?",
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    UNASSIGN_CANDIDATE_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure you want to unassign this candidate?",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    UPDATE_RATE_BASED_ON_BOOKING_SERVICE_CONFIRM_DIALOG: {
        MESSAGE: "Do you want to update the client rate and candidate rate accordingly?",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    DELETE_BREAK_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure you want to delete this break?",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    BULK_CHARGE_CLIENT_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Are you sure you want to charge clients for the following jobs?</h3>
        <ul>{0}</ul>`,
        ACCEPT_LABEL: "Charge",
        REJECT_LABEL: "Cancel"
    },
    BULK_INVOICE_STRIPE_CLIENT_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Are you sure you want to send invoice to clients through Stripe for the following jobs?</h3>
        <ul>{0}</ul>`,
        ACCEPT_LABEL: "Send Invoice",
        REJECT_LABEL: "Cancel"
    },
    BULK_CHARGE_PAYOUT_STRIPE_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Are you sure you want to charge clients and payout candidates through Stripe for the following jobs?</h3>
        <ul>{0}</ul>`,
        ACCEPT_LABEL: "Transfer",
        REJECT_LABEL: "Cancel"
    },
    BULK_COPY_SUGGESTED_CHARGE_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Are you sure you want to copy suggested charge to total client charge for the following jobs?</h3>
        <ul>{0}</ul>`,
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    SHARE_JOB_MARKET_PLACE_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Are you sure you want to share this job to the agency marketplace with the following fee?</h3>
        <ul>{0}</ul>`,
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    CLOSE_VIEW_TAB_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to close the view {0}',
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    DELETE_TODO_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this To Do?',
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    DELETE_BENEFIT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the benefit {0}?',
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    TRANSER_MONEY_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to send {0}{1} to {2}? ',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    MARK_JOB_COMPLETED_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to mark this job as completed?',
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    DELETE_PACKAGE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this package?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    REPORT_PROBLEM_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to report the problem?',
        ACCEPT_LABEL: "Report",
        REJECT_LABEL: "Cancel"
    },
    COPY_FIELD_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to copy data from {0} to {1}?',
        INNER_HTML: `<h3>Are you sure you want to copy data?</h3>
        <h4>From Field: {0}</h4>
        <h4>To Field: {1}</h4>
        <h5>All of the existing data of {1} will be overwritten</h5>`,
        ACCEPT_LABEL: "Copy",
        REJECT_LABEL: "Cancel"
    },
    CANCEL_SCHEDULE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to cancel the email?',
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    DELETE_REVIEW_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this review?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_BLOCK_TEXT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this block of text?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_STRIPE_ACCOUNT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete stripe account of this user?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DEDUPLICATE_CHILDREN_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to remove duplicated children?',
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    HIDE_FIELD_FROM_CLIENT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to hide this field from client?',
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    SHOW_FIELD_TO_CLIENT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to show this field to client?',
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    BOOKING_IN_PAST_DATE_CONFIRM_DIALOG: {
        MESSAGE: 'Booking is in a past date. Do you want to continue?',
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    RESTORE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to restore the {0}?',
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    PERMANENT_DELETE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to permanently delete the {0}?',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    BULK_DELETE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete {0} selected {1}?',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    BULK_SHIFT_JOB_UPDATE_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure you want to update {0} jobs",
        ACCEPT_LABEL: "Update",
        REJECT_LABEL: "Cancel"
    },
    INVALID_INPUT_WARNING_CONFIRM_DIALOG: {
        INNER_HTML: `
        <h2>Warning, you have not filled some required fields</h2>
        <h4 class="error-message main-message">
        These are the missing fields:
        </h4>
        <ul>{0}</ul>
        <h5 class="mt-2">Click Continue to ignore the warning</h5>
        `,
        ACCEPT_LABEL: "Continue",
        REJECT_LABEL: "Cancel"
    },
    SEND_REPEAT_BLAST_TEMPLATE_CONFIRM_DIALOG: {
        INNER_HTML: `
        <h2>Are you sure you want to send repeated {0} to {1}</h2>
        <h5>Template: {2}</h5>
        <h5>Repeat every {3} days {4}</h5>`,
        ACCEPT_LABEL: "Send",
        REJECT_LABEL: "Cancel"
    },
    DUPLICATE_FIELD_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to duplicate the field?',
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    DELETE_FIELD_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this field?',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_PROFILE_FIELD_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this field? This will delete it from the profile overall (not just for this one person!)',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    MAKE_FIELD_VISIBLE_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure you want to set this field to be visible to client",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    MAKE_FIELD_HIDDEN_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure you want to set this field to be hidden from client",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    HIDE_BENEFIT_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure you want to hide this benefit for your agency",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    ASSIGN_JOB_DETAIL_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Are you sure you want to {0} the job to the candidate?</h3>
        <p>Job: {1}</p>
        <p>Poster: {2}</p>
        <p>Candidate: {3}</p>`,
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    }
}



// WEBPACK FOOTER //
// ./src/constants/multi-languages/confirm-dialog/en.js